import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import lodashGet from 'lodash/get';
import { SvgIcon } from '@adsk/bim360-matrix-react-components';

class Zoomable extends PureComponent {
  static displayName = 'Zoomable';

  static propTypes = {
    img: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      scale: 1,
      lastPos: [0, 0],
      mouse: [0, 0],
      delta: [0, 0],
      isPressed: false,
    };

    this.width = 860;
    this.height = 530;

    this.handleMouseMove = this.handleMouseMove.bind(this);
  }

  componentDidMount() {
    window.addEventListener('mousemove', this.handleMouseMove);
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.handleMouseMove);
    this.resetScale();
  }

  zoomIn() {
    this.setState({
      scale: this.state.scale * 2,
      lastPos: [0, 0],
      mouse: [0, 0],
      delta: [0, 0],
    });
  }

  zoomOut() {
    this.setState({
      scale: Math.max(1, this.state.scale / 2),
      lastPos: [0, 0],
      mouse: [0, 0],
      delta: [0, 0],
      max: [500, 500],
    });
  }

  resetScale() {
    this.setState({
      scale: 1,
      lastPos: [0, 0],
      mouse: [0, 0],
      delta: [0, 0],
    });

  }

  _controls() {
    const disabledStyle = {
      opacity: this.state.scale === 1 ? 0.5 : 1,
    };

    return (
      <div className="controls">
        <div className="zoom-in" onClick={() => { this.zoomIn(); }}>+</div>
        <div className="zoom-out" style={disabledStyle} onClick={() => { this.zoomOut(); }}>-</div>
      </div>
    );
  }

  handleMouseDown(e) {
    this.setState({
      isPressed: true,
      mouse: [e.clientX, e.clientY],
    });
  }

  handleMouseMove(e) {
    // trigger mouseup if outside of container
    let className = lodashGet(e, 'target.className.baseVal') || lodashGet(e, 'target.className', '');
    if (typeof className !== 'string') {
      className = '';
    }
    if (className.indexOf('inner') === -1) {
      this.handleMouseUp();
    }

    if (this.state.isPressed) {
      const { lastPos } = this.state;
      const xLimit = Math.abs(lastPos[0] + e.clientX - this.state.mouse[0]) >= (this.width * this.state.scale - this.width) / 4;
      const yLimit = Math.abs(lastPos[1] + e.clientY - this.state.mouse[1]) >= (this.height * this.state.scale - this.height) / 4;

      // check limits
      if (xLimit || yLimit) {
        return;
      }

      this.setState({
        delta: [e.clientX - this.state.mouse[0], e.clientY - this.state.mouse[1]],
      });
    }
  }

  handleMouseUp() {
    const { lastPos, delta } = this.state;

    this.setState({ isPressed: false, delta: [0, 0], lastPos: [lastPos[0] + delta[0], lastPos[1] + delta[1]] });
  }

  render() {
    const classes = classnames('zoomable-container', {});
    const innerClasses = classnames('inner', {
      dragging: this.state.isPressed,
    });
    const { scale, lastPos, delta } = this.state;

    return (
      <div className={classes}>
        {this._controls()}
        <div
          className={innerClasses}
          onMouseDown={(e) => this.handleMouseDown(e)}
          onMouseUp={(e) => this.handleMouseUp(e)}
          style={{
            transform: `scale(${scale}) translate(${lastPos[0] + delta[0]}px, ${lastPos[1] + delta[1]}px)`,
          }}
        >
          <SvgIcon width="100%" height="100%" className="zoomable-inner-svg">
            {this.props.img}
          </SvgIcon>
        </div>
      </div>
    );
  }
}

export default Zoomable;

